import { render, staticRenderFns } from "./CodeTextArea.vue?vue&type=template&id=dd3e6d28"
import script from "./CodeTextArea.vue?vue&type=script&lang=js"
export * from "./CodeTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd3e6d28')) {
      api.createRecord('dd3e6d28', component.options)
    } else {
      api.reload('dd3e6d28', component.options)
    }
    module.hot.accept("./CodeTextArea.vue?vue&type=template&id=dd3e6d28", function () {
      api.rerender('dd3e6d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/code-textarea/CodeTextArea.vue"
export default component.exports